import React from "react";
import Navbar from "./components/Navbar";
import Cover from "./components/Cover";
import TypedAnimation from "./components/TypedAnimation";
import Typing from "./components/Typing";
import Nav from "./components/Nav";
import { MyComponent } from "./components/Typing";
import SectionTwo from "./components/SectionTwo";
import ContactSection from "./components/ContactSection";


function App() {
  return (
    <React.Fragment>
    <Nav/>
    <Cover/>
    <SectionTwo/>
    </React.Fragment>
   
  );
}

export default App;
